/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["자정", "정오", "새벽", "오전", "오후", "저녁", "밤"], u, u], u, ["00:00", "12:00", ["03:00", "06:00"], ["06:00", "12:00"], ["12:00", "18:00"], ["18:00", "21:00"], ["21:00", "03:00"]]];
